import { Stack, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { SearchBar } from './index'

import { logo } from '../utils/constants';

function Navbar() {
    return(
        <Stack 
            direction="row" 
            alignItems="center" 
            p={2} 
            sx={{ position: 'sticky', background: '#000', top: 0, justifyContent: 'space-between' }}
        >
            <Link to="/" style={{ display: 'flex', alignItems: 'center', columnGap: '10px' }}>
                <img src={logo} alt="logo" height={45} />
                <Typography variant="h4" color="#fff" fontWeight="bold">YouTube Clone</Typography>
            </Link>
            <SearchBar />
        </Stack>
    );
}

export default Navbar;